import { Chip } from '@mui/material';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  coverage: number | null;
  size?: 'small' | 'medium';
};

const CoverageCell = ({ coverage, size = 'medium' }: Props) => {
  const { t } = useTranslation('common');

  const getCoverageColor = (coverageDays: number | null) => {
    if (coverageDays === null) return 'default';
    if (coverageDays <= 7) return 'error';
    if (coverageDays <= 30) return 'warning';
    return 'success';
  };

  const formatted = coverage !== null ? Number(coverage).toFixed(2) : coverage;
  return <Chip size={size} variant='filled' color={getCoverageColor(coverage as number)} label={t(`${Number(formatted)} ${t('days')}`)} />;
};

export default memo(CoverageCell);
